import {FeatureCard} from 'shells/ai-homepage/ai-feature-card/feature-card';
import {CommentSmileRegularIcon, MedalRegularIcon} from 'shells/icon';
import {Stack} from 'shells/layout/stack/stack';

import {appHistory} from '../../../history';

import {useNutshellSurvey} from '../../internal-feedback/hooks/use-nutshell-survey';
import {useGetReview} from '../../leave-a-review/graphql/hooks/use-get-review';

import {ExplorePageSectionHeader} from './explore-page-section-header';

export function MakeNutshellBetterSection() {
    const {openSurvey: openFeedbackSurvey, SurveyModal} = useNutshellSurvey();
    const {review} = useGetReview();

    const handleLeaveReview = () => {
        if (review?.reviewLink) {
            window.open(review.reviewLink, '_blank');
        }
    };

    return (
        <Stack spacing={16}>
            <ExplorePageSectionHeader title='Make Nutshell better' />
            <Stack isHorizontal={true} spacing={16}>
                <div className='half-width'>
                    <FeatureCard
                        title='Share your feedback!'
                        description='Let us know how we can make this product even better'
                        history={appHistory}
                        thumbnail={{
                            backgroundColor: 'tagBlueLt',
                            illustration: 'trial-onboarding/user-feedback',
                        }}
                        variant='feature'
                        icon={CommentSmileRegularIcon}
                        cta={{
                            text: 'Leave feedback',
                            onClick: openFeedbackSurvey,
                        }}
                    />
                </div>
                {/* Render the half width section even if the card isn't there to keep the layout intact */}
                <div className='half-width'>
                    {NutClientConfig.canLeaveG2Review && (
                        <FeatureCard
                            title='Do you love using Nutshell?'
                            description='Leave a G2 review to help Nutshell improve features for everyone'
                            history={appHistory}
                            thumbnail={{
                                backgroundColor: 'tagBlueLt',
                                illustration: 'trial-onboarding/g2-review',
                            }}
                            variant='feature'
                            icon={MedalRegularIcon}
                            cta={{
                                text: 'Leave a review',
                                onClick: handleLeaveReview,
                            }}
                        />
                    )}
                </div>
            </Stack>
            {SurveyModal}
        </Stack>
    );
}
